import { render, staticRenderFns } from "./CompraConab.vue?vue&type=template&id=3ecf3bd8&"
import script from "./CompraConab.vue?vue&type=script&lang=js&"
export * from "./CompraConab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports